import React from "react"
import axios from 'axios';
import { PersonResultTable } from './results/PersonResultTable.jsx';
import { AccountSearchTipsBig } from '../tips/AccountSearchTipsBig.jsx';
import { AccountSearchTipsSmall } from '../tips/AccountSearchTipsSmall.jsx';
import { NewPersonOrCompany } from '../forms/switches/NewPersonOrCompany.jsx';
import { NewExhibitor } from '../forms/switches/NewExhibitor.jsx';
import I18n from 'i18n-js';
import '../translations.js';

export class AccountSearchForm extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      newForm: this.props.skipSearch,
      showTable: false,
      resultArray: []
    };
    this.searchExistingUsers = this.searchExistingUsers.bind(this);
    this.searchExistingCompanies = this.searchExistingCompanies.bind(this);
    this.updateResultTable = this.updateResultTable.bind(this);
    this.showNewForm = this.showNewForm.bind(this);
  }

  searchExistingUsers(e) {
    e.preventDefault();
    axios.post('/api/v1/search/user_search', {
      first_name: this.first_name.value,
      last_name: this.last_name.value
      })
      .then(response => this.updateResultTable(response.data))
      .catch(error => this.setState({ errorMessage: 'Error...'}));
  }

  searchExistingCompanies(e) {
    e.preventDefault();
    axios.post('/api/v1/search/company_search', { company_name: this.company_name.value })
      .then(response => this.updateResultTable(response.data))
      .catch(error => this.setState({ errorMessage: 'Error...'}));
  }


  updateResultTable(data) {
    this.setState({ 
      showTable: true,
      resultArray: data.users 
    });
  }

  showNewForm() {
    this.setState({ newForm: true });
  }

  render () {
    return (
      <div>
       {!this.state.newForm ?
          <div>
            <div className="row">
              { this.props.type == "person" ? 
                <h2>{ I18n.t("exhibitor.person_search") }</h2> :
                <h2>{ I18n.t("exhibitor.company_search") }</h2>
              }
              <div className="alert alert-danger">
                <p>{ I18n.t("important_all_caps") }</p>
                <ul>
                  <li>{ I18n.t("exhibitor.search_before_create") }</li>
                  <br/>
                  <li>{ I18n.t("exhibitor.do_not_create_dupe") }</li>
                </ul>
              </div>

              {this.props.type === "person" ?
                <form onSubmit={this.searchExistingUsers}>
                  <input type="text" placeholder={ I18n.t("first_name") } minLength="2" key="1" ref={input => this.first_name = input} />
                  <input type="text" placeholder={ I18n.t("last_name") } minLength="2" key="2" ref={input => this.last_name = input} />
                  <button className="btn btn-info">{ I18n.t("search") }</button>
                  <p>{ I18n.t("exhibitor.person_search_hint") }</p>
                </form>
                : this.props.type === "company" ?
                <form onSubmit={this.searchExistingCompanies}>
                  <input type="text" placeholder={ I18n.t("company_name") } minLength="2" key="3" ref={input => this.company_name = input} />
                  <button className="btn btn-info">{I18n.t("search")}</button>
                  <p>{ I18n.t("exhibitor.company_search_hint") }</p>
                </form>
                :
                undefined
              }
              <div>
                {this.state.showTable ? 
                  <div>
                    <PersonResultTable results={this.state.resultArray} />
                    <br/>
                    <br/>
                    { this.props.createUserData.registrant ? 
                      <AccountSearchTipsSmall/>
                    : <AccountSearchTipsBig/> }
                    <br/>
                    <button className="btn btn-success" onClick={this.showNewForm}>{ I18n.t("exhibitor.create_new_person_company_button_label") }</button>
                    <br/>
                  </div>
                  : undefined
                }
                <br/>
                <button className="btn btn-success" onClick={this.props.goBack}>{ I18n.t("back_button_label") }</button>
              </div>
            </div>
          </div>
          : this.props.createUserData.registrant ? 
              <NewPersonOrCompany 
                createUserData={ this.props.createUserData }
                type={this.props.type}
                userData={this.props.userData}
                usef={this.props.usef}
                ec={this.props.ec}
                fei={this.props.fei}
              />
            : <NewExhibitor 
                createUserData={ this.props.createUserData }
                type={this.props.type}
                userData={this.props.userData}
                usef={this.props.usef}
                ec={this.props.ec}
                fei={this.props.fei}
              />
        }
      </div>
    );
  }
}

